import isMessageModerated from './is_message_moderated'
import isUserAllowedToSeeModeratedMessage from './is_user_allowed_to_see_moderated_message'

const byVisibilityForUser = (uid, role, message) => {
  if (!isMessageModerated(message)) return true

  const from = message.get('from')
  const approvalStatus = message.get('approvalStatus')

  if (isUserAllowedToSeeModeratedMessage(from, uid, approvalStatus, role)) return true

  return false
}

export default (messages, uid = null, role = null) => {
  return messages.filter(byVisibilityForUser.bind(null, uid, role))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/filter_not_approved_messages.js
 **/